export const ADD_DEPARTMENT = 'searchResultPage/ADD_DEPARTMENT';
export const ADD_SEARCH_TERM = 'searchResultPage/ADD_SEARCH_TERM';
export const CLEAR_ALL_FILTERS = 'searchResultPage/CLEAR_ALL_FILTERS';
export const CLEAR_ALL_FILTERS_V2 = 'searchResultPage/CLEAR_ALL_FILTERS_V2';
export const CLEAR_FILTER_SECTION = 'searchResultPage/CLEAR_FILTER_SECTION';
export const CLEAR_FILTER_SECTION_V2 = 'searchResultPage/CLEAR_FILTER_SECTION_V2';
export const FETCH_FILTERS = 'searchResultPage/FETCH_FILTERS';
export const FETCH_FILTERS_FAILURE = 'searchResultPage/FETCH_FILTERS_FAILURE';
export const FETCH_FILTERS_REQUEST = 'searchResultPage/FETCH_FILTERS_REQUEST';
export const FETCH_FILTERS_SUCCESS = 'searchResultPage/FETCH_FILTERS_SUCCESS';
export const TOGGLE_FILTER = 'searchResultPage/TOGGLE_FILTER';
export const TOGGLE_FILTER_SELECTION = 'searchResultPage/TOGGLE_FILTER_SELECTION';
export const TOGGLE_INFO_CARD_VISIBILITY = 'searchResultPage/TOGGLE_INFO_CARD_VISIBILITY';
export const TOGGLE_SORT_MODAL_VISIBILITY = 'searchResultPage/TOGGLE_SORT_MODAL_VISIBILITY';
export const UPDATE_DEPARTMENT_SELECTION = 'searchResultPage/UPDATE_DEPARTMENT_SELECTION';
export const UPDATE_FILTER_SELECTION = 'searchResultPage/UPDATE_FILTER_SELECTION';
